export const SET_STATE_MY_ACCOUNT = 'SET_STATE_MY_ACCOUNT';
export const SET_VISIBLE_FORM_VEHICLE = 'SET_VISIBLE_FORM_VEHICLE';
export const SET_STATE_FORM_VEHICLE = 'SET_STATE_FORM_VEHICLE';
export const SET_STATE_MODAL_CONFIRMATION = 'SET_STATE_MODAL_CONFIRMATION';
export const RESET_MODAL_CONFIRMATION = 'RESET_MODAL_CONFIRMATION';
export const SET_DETAIL_VEHICLE = 'SET_DETAIL_VEHICLE';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_ECERTIFICATE = 'SET_ECERTIFICATE';
export const SET_ERECEIPT = 'SET_ERECEIPT';
